import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import { PostDataAPI } from '../../../../Services/APIService';
import DialogLoader from './../../../../components/Loader/DialogLoader';
import SearchGrid from "./../../../../components/table/SearchGrid";
import { formatDate, formateMdnNumber, maskAccountNumber, formatDateTime } from '../../../../../src/components/Common/Extensions';

import useStyles from "./styles";
import Loader from './../../../../components/Loader/Loader';
import { withSnackbar } from "./../../../../components/Message/Alert";

function ViewAllUsage({ dialogOpenClose, handleClose, handleSuccessClose, accountNumber, filter, ...props }) {
    const classes = useStyles();
    const [state, setState] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { showMessage } = props;
    const [isUpdate, setIsUpdate] = useState(false);
    const handleUpdate = () => {
        setIsUpdate(!isUpdate);
    }
    const getAccountUsageSummaryForPreviousMonths = () => {
        let isIncludePreviousCycles = filter > 1 ? true : false;

        var obj = { AccountNumber: accountNumber, isIncludePreviousCycles: isIncludePreviousCycles, filter: filter };
        setIsLoading(true);
        PostDataAPI("telispire/getAccountUsageSummaryForPreviousMonths", obj, true).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                setState(result.data);
                handleUpdate();
            }
        })

    }
    useEffect(() => {
        getAccountUsageSummaryForPreviousMonths();
    }, [])

    return (
        <>
       
            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableEscapeKeyDown
                open={dialogOpenClose}
                maxWidth="lg"
                {...props} >
                    
                <div className={classes.dialogContent}>
              
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>Usage Details - {maskAccountNumber(accountNumber)}</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>

                        <div className={classes.content}>
                           
                            <Scrollbars autoHeight autoHeightMin={150} autoHeightMax={600}>
                                {isLoading ? <DialogLoader></DialogLoader> : ''}
                                <SearchGrid
                                    columns="usageDetailsData"
                                    list={state}
                                    noRecordMsg="No call detail exists"s
                                    isUpdate={isUpdate}
                                />
                            </Scrollbars>
                        </div>
                        <div className={classes.footer}>

                            <div className={classes.footerRight}>

                                <Button className={classes.backBtn} onClick={handleClose}>Close</Button>



                            </div>
                        </div>
                    </div>
                </div>
            </Dialog >
        </>
    )
}
export default withSnackbar(ViewAllUsage);
